import { Button, Checkbox, Col, Input, message, Popconfirm, Row } from "antd";
import { ScheduleOutlined } from "@ant-design/icons";
import axios from "axios";
import React, { useEffect, useState } from "react";
import API_HOST from "../config.js";

export default function FinishAcctsFunction(props) {
  const [messageApi, contextHolder] = message.useMessage();

  const [sheetURL_p, setSheetURL_p] = useState('');
  const [sheetName_p, setSheetName_p] = useState('');

  const [quantity, setQuantity] = useState('5');
  const [sheetURL_v, setSheetURL_v] = useState('');
  const [sheetName_v, setSheetName_v] = useState('');
  const [verifyPayment, setVerifyPayment] = useState(true);
  const [manual, setManual] = useState(true);

  const [tabsNum, setTabsNum] = useState('5');

  const finish = async (profile) => {
    if(!sheetURL_p || !sheetURL_v) {
      alert("Data GG Sheet chưa nhập !!!")
      return;
    }
    
    messageApi.info(`>>> Finish Profiles...`);
    let body = {
      sheetProfiles: {
        sheetId: sheetURL_p.split('/d/')[1].split('/edit')[0], 
        sheetName: sheetName_p,
      },
      sheetVisa: {
        quantity,
        sheetId: sheetURL_v.split('/d/')[1].split('/edit')[0], 
        sheetName: sheetName_v,
      },
      tabsNum,
      verifyPayment,
      manual
    };
    axios
      .post(`${API_HOST}/api/finish-profiles`, body)
      .then((res) => messageApi.success("Đang chạy..."))
      .catch((e) => {
        console.log("🚀 ~ Finish Profiles ~ error:", e);
        messageApi.error(e.response.data);
      });
  };
  useEffect(() => {
    let sheetNameP = localStorage.getItem('finish-profile-sheetName')
    if(sheetNameP) {
      setSheetName_p(sheetNameP)
    }
    let sheetURLP = localStorage.getItem('finish-profile-sheetURL')
    if(sheetURLP) {
      setSheetURL_p(sheetURLP)
    }

    let sheetName = localStorage.getItem('tkcn-sheetName')
    if(sheetName) {
      setSheetName_v(sheetName)
    }
    let sheetURL = localStorage.getItem('tkcn-sheetURL')
    if(sheetURL) {
      setSheetURL_v(sheetURL)
    }
    let quantity = localStorage.getItem('tkcn-quantity')
    if(quantity) {
      setQuantity(quantity)
    }

    let tabsNum = localStorage.getItem('finish-profile-tabs')
    if(tabsNum) {
      setTabsNum(tabsNum)
    }
  
    let verifyPayment = localStorage.getItem('finish-profile-verifyPayment')
    if(verifyPayment) {
      setVerifyPayment(verifyPayment === 'true')
    }
    let manual = localStorage.getItem('finish-profile-manual')
    if(manual) {
      setManual(manual === 'true')
    }
  }, [])

  return (
    <>
      {contextHolder}
      <Popconfirm
        style={{ width: '500px' }}
        placement="left"
        okText="OK"
        cancelText="Hủy"
        title="Xác nhận: Hoàn Thành Profiles"
        description={
          <div style={{ width: '500px' }}>
            <b>Profiles GG sheet: </b>
            <Row>
              <Col span={4}>
                <label>SL Chrome: </label>
              </Col>
              <Col span={20}>
                <Input
                  value={tabsNum}
                  type="number"
                  style={{ width: 60 }}
                  placeholder="Số Lượng Chrome..."
                  onChange={(e) => {
                    setTabsNum(e.target.value);
                    localStorage.setItem('finish-profile-tabs', e.target.value);
                  }}
                />
              </Col>
              <Col span={4}>
                <label>URL: </label>
              </Col>
              <Col span={18}>
               <Input
                  value={sheetURL_p}
                  style={{ width: 400 }}
                  placeholder="https://docs.google.com/spreadsheets/d/15CVrJD5DBJ5k..."
                  onChange={(e) => {
                    setSheetURL_p(e.target.value);
                    localStorage.setItem('finish-profile-sheetURL', e.target.value);
                  }}
                />
              </Col>
              <Col span={4}>
                <label>Trang: </label>
              </Col>
              <Col span={18}>
                 <Input
                    value={sheetName_p}
                    style={{ width: 200 }}
                    placeholder="LOGIN EMAIL"
                    onChange={(e) => {
                      setSheetName_p(e.target.value);
                      localStorage.setItem('finish-profile-sheetName', e.target.value);
                    }}
                  />
              </Col>
            </Row>

            <br/>
            <b>VISA GG sheet: </b>
            <Row>
              <Col span={4}>
                <label>S.Lượng TK: </label>
              </Col>
              <Col span={18}>
                <Input
                  value={quantity}
                  type="number"
                  style={{ width: 60 }}
                  placeholder="Số Lượng ..."
                  onChange={(e) => {
                    setQuantity(e.target.value)
                    localStorage.setItem("tkcn-quantity", e.target.value);
                  }}
                />
              </Col>
        
              <Col span={4}>
                <label>URL: </label>
              </Col>
              <Col span={18}>
               <Input
                  value={sheetURL_v}
                  style={{ width: 400 }}
                  placeholder="https://docs.google.com/spreadsheets/d/15CVrJD5DBJ5k..."
                  onChange={(e) => {
                    setSheetURL_v(e.target.value);
                    localStorage.setItem('tkcn-sheetURL', e.target.value);
                  }}
                />
              </Col>
              <Col span={4}>
                <label>Trang: </label>
              </Col>
              <Col span={18}>
                 <Input
                    value={sheetName_v}
                    style={{ width: 200 }}
                    placeholder="VISA"
                    onChange={(e) => {
                      setSheetName_v(e.target.value);
                      localStorage.setItem('tkcn-sheetName', e.target.value);
                    }}
                  />
              </Col>
              <Col span={10}>
                  <label>Xác Minh VISA</label>
              </Col>
              <Col span={14}>
                  <Checkbox checked={verifyPayment} onChange={e => {
                      setVerifyPayment(e.target.checked)
                      localStorage.setItem("finish-profile-verifyPayment", `${e.target.checked}`);
                    }}>
                  </Checkbox>
              </Col>
              <Col span={10}>
                  <label>Lấy CODE Thủ Công</label>
              </Col>
              <Col span={14}>
                <Checkbox checked={manual} onChange={e => {
                    setManual(e.target.checked);
                    localStorage.setItem("finish-profile-manual", `${e.target.checked}`);
                  }}>
                </Checkbox>
              </Col>
                          
            </Row>
          </div>
        }
        onConfirm={() => finish(props.profile)}
      >
        <Button style={{backgroundColor:'green', color:'white'}} ><ScheduleOutlined />Finish</Button>
      </Popconfirm>
    </>
  );
}